import React, {useEffect, useState} from 'react';
import Grid from '@material-ui/core/Grid'
import MyProfileIaEvaluationStyled from './styled'
import {Box, LinearProgress} from '@material-ui/core'
import RegularButton from '../../atoms/regular-button';
import MaterialTable from 'material-table';
import { Archive, CheckCircle2, Circle, PencilLine, Power, PowerOff, Star, ThumbsDown, ThumbsUp } from 'lucide-react'
import { MTText, SearchInput, ToggleTabs, ActionsCell, ActionsGroup } from '../../atoms'
import { ModalDisableEvaluationProfile } from '../../molecules'
import { tokens } from '../../../assets/tokens'
import {EVALUATION_CRITERIA} from '../../../config/constants'
import _, {find} from 'lodash';
import i18n from '../../../assets/i18n'
import MTPagination from '../../atoms/mt-pagination'
import {
  useIaEvaluationProfiles,
} from "../../../api/queries/useIaEvaluationProfile";
import {useEvaluationCriteria} from "../../../api/queries/useIaEvaluationCriteria";
import routes from "../../../config/routes";
import {useHistory} from "react-router-dom";

const MyProfileIaEvaluation = () => {
  const history = useHistory();
  const [searchTerm, setSearchTerm] = useState("");
  const [isModalDisableOpen, setIsModalDisableOpen] = useState(false);
  const [editingEvaluationData, setEditingEvaluationData] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [alert, setAlert] = useState({ message: '', severity: '' })

  const [showActivesTable, setShowActivesTable] = useState(true);
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [range, setRange] = useState([0, 9]);

  useEffect(() => {
    if (alert.message) {
      setShowAlert(true);
      const timer = setTimeout(() => {
        setShowAlert(false);
        setAlert({ message: '', severity: '' });
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [alert]);

  const getRange = (pageVal, perPageVal) => {
    return [pageVal * perPageVal, perPageVal * (pageVal + 1) - 1];
  }

  useEffect(() => {
    setRange(getRange(page, perPage));
  }, [page, perPage]);

  const { data: evaluationCriteria, isLoading: isLoadingCriteria} = useEvaluationCriteria();
  const { data: evaluationProfiles, isLoading} = useIaEvaluationProfiles(searchTerm, showActivesTable, range);

  let tableColumns = {
    name: {
      title: i18n.ia_evaluation.name,
      render: (row) => {
        return <MTText value={row.name} style={{ fontWeight: '400' }} />;
      },
      field: 'name',
      sorting: false,
    },
    job: {
      title: i18n.ia_evaluation.job,
      render: (row) => {
        return <MTText value={row.job.name} style={{ fontWeight: '400' }} />;
      },
      field: 'job',
      sorting: false,
    },
  };

  const actionColumns = {
    actions: {
      title: i18n.user_management.actions,
      sorting: false,
      headerStyle: { width: 96, whiteSpace: 'nowrap' },
      cellStyle: { width: 96 },
      render: function ActionsColumn(row) {
        const isActive = row.is_active;
        return (
          <ActionsGroup>
            <ActionsCell
              icon={<PencilLine size={18} color={tokens.color.text.secondary} />}
              tooltip={i18n.ia_evaluation.wizard.title_edit}
              onClick={() => handleEditEvaluation(row)}
            />
            <ActionsCell
              icon={isActive
                ? <PowerOff size={18} color={tokens.color.text.secondary} />
                : <Power size={18} color={tokens.color.text.secondary} />}
              tooltip={isActive ? i18n.ia_evaluation.disable : i18n.ia_evaluation.enable}
              onClick={() => handleDisableAndEnableIconClick(row)}
            />
          </ActionsGroup>
        );
      },
      field: 'actions',
      hidden: false,
    }
  };

  // Mismos iconos en las celdas y en la leyenda; los colores de siempre, pasados a tokens
  const relevanceIcons = {
    [EVALUATION_CRITERIA.RELEVANT]: <Star size={16} color={tokens.color.category.desired} />,
    [EVALUATION_CRITERIA.DESIRED]: <ThumbsUp size={16} color={tokens.color.success.main} />,
    [EVALUATION_CRITERIA.MANDATORY]: <ThumbsDown size={16} color={tokens.color.error.main} />,
    [EVALUATION_CRITERIA.IGNORE]: <Circle size={16} color={tokens.color.text.tertiary} />,
  };

  let criteriaColumns = {};
  if (evaluationCriteria) {
    evaluationCriteria.forEach(criteria => {
      criteriaColumns[criteria.keyword] = {
        title: i18n.ia_evaluation.criteria[criteria.keyword],
        render: (row) => {
          let relevance = find(row.evaluation_profile_criterias, {evaluation_criteria: {keyword: criteria.keyword}});
          if (!relevance) return '';
          return relevanceIcons[relevance.relevance_level] || '';
        },
        field: criteria.keyword,
        sorting: false,
      };
    });
  }

  tableColumns = {...tableColumns, ...criteriaColumns, ...actionColumns};

  const handleSearchTerm = _.debounce((value) => {
    setSearchTerm(value);
  }, 1500);

  let tableOptions = {
    emptyRowsWhenPaging: false,
    loadingType: 'linear',
    cellStyle: { textAlign: 'center' },
    pageSize: perPage,
    pageSizeOptions: [10, 20, 50, 100],
    toolbar: false,
    draggable: false,
    selection: false,
  }
  const handleCreateEvaluation = () => {history.push(routes.iaEvaluationCreate)}
  const handleEditEvaluation = (row) => {history.push(routes.iaEvaluationEdit.replace(':id', row.id))}

  const handleDisableAndEnableIconClick = (row) => {
    setEditingEvaluationData(row);
    setIsModalDisableOpen(true);
  };

  const columnsArray = Object.values(tableColumns);

  columnsArray.forEach(column => {
    if (column.render) {
      column.render.displayName = `${column.field}_render`;
    }
  });

  const handleChangePage = (event, newPage) => {setPage(newPage)}

  const handleChangePerPage = (event) => {
    setPerPage(parseInt(event.target.value,10));
    setPage(0);
  }

  return (
    <MyProfileIaEvaluationStyled>
      <div className="containerHeader">
        <Grid container spacing={4}>
          <Grid item className="sectionSecond" xs={12} sm={12}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: "flex-start", gridGap: '15px', maxWidth: "800px", }}>
              <h2>{i18n.ia_evaluation.titleSection}</h2>
              <h5>{i18n.ia_evaluation.descriptionSection}</h5>
            </Box>
            <Box sx={{ display: 'flex', alignItems: "flex-start", placeSelf: 'flex-start' }}>
              <RegularButton className="button-custom" title={i18n.ia_evaluation.createEvaluation}
                             onClick={handleCreateEvaluation}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} >
            {/* La fila de filtros queda fuera de la carga para no perder el foco del buscador */}
            <div className="headerTable">
              <SearchInput
                placeholder={i18n.ia_evaluation.placeholderInputTerm}
                onChange={value => handleSearchTerm(value)}
              />
              <ToggleTabs
                value={showActivesTable}
                onChange={(value) => {
                  setShowActivesTable(value);
                  setPage(0);
                }}
                tabs={[
                  { label: i18n.ia_evaluation.active, value: true, icon: CheckCircle2 },
                  { label: i18n.ia_evaluation.inactive, value: false, icon: Archive }
                ]}
              />
            </div>
            {isLoadingCriteria || isLoading ? <LinearProgress/>
              :
              <>
                <div className="relevance_level_legend">
                  {[EVALUATION_CRITERIA.RELEVANT, EVALUATION_CRITERIA.DESIRED, EVALUATION_CRITERIA.MANDATORY, EVALUATION_CRITERIA.IGNORE].map(level => (
                    <div key={level}>{relevanceIcons[level]}{i18n.ia_evaluation.relevance_level[level]}</div>
                  ))}
                </div>
                {evaluationProfiles && <MaterialTable
                  key={showActivesTable ? 'active-evaluations' : 'inactive-evaluations'}
                  data={evaluationProfiles.data}
                  columns={columnsArray}
                  options={tableOptions}
                  components={{
                    // Sin el Paper por defecto de material-table, como en el resto de páginas de admin
                    Container: props => <div {...props} />,
                    Pagination: () => <MTPagination
                      rowsPerPageOptions={[10, 20, 50, 100]}
                      rowsPerPage={perPage}
                      count={evaluationProfiles.total}
                      page={page}
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangePerPage}
                    />
                  }}
                />}
              </>
            }
          </Grid>
          <ModalDisableEvaluationProfile
            open={isModalDisableOpen}
            handleClose={() => setIsModalDisableOpen(false)}
            evaluationData={editingEvaluationData}
            showAlert={showAlert}
            alert={alert}
            setAlert={setAlert}
          />
        </Grid>
      </div>
    </MyProfileIaEvaluationStyled>
  );

};

export default MyProfileIaEvaluation;
